import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "contrainer"
};
import { useRouter } from "vue-router";
import NavBar from "./components/v-nav-bar.vue";
import { useI18n } from "vue-i18n";
import { applyTheme, setServiceType } from "./utils/theme";
import { initUser } from "./utils/auth";
export default {
  __name: 'App',
  setup(__props) {
    const i18n = useI18n();
    const router = useRouter();
    const logout = () => {
      localStorage.clear();
      window.location.reload();
    };
    let firstNavigation = true;
    router.beforeEach((to, from, next) => {
      const query = to.query;
      if (query.i18n) {
        i18n.locale.value = query.i18n;
        localStorage.setItem("i18n", query.i18n);
      }
      if (query.token) {
        localStorage.setItem("token", query.token);
      }
      if (query.serviceType) {
        setServiceType(query.serviceType);
      }
      if (query.serviceId) {
        localStorage.setItem("serviceId", query.serviceId);
      }
      applyTheme();
      if (firstNavigation) {
        firstNavigation = false;
        initUser();
      }
      next();
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(NavBar), _createVNode(_component_router_view)]);
    };
  }
};